<template>
<div class="error_page">
    <div class="error_img" :class="`error_${code}`"></div>
    <div class="error_info">
        <h1>{{code}}</h1>
        <p>{{msg?msg:message[code]?message[code]:'抱歉，页面出错了'}}</p>
        <a href="javascript:history.go(-1);"><a-button type="primary" :block="false">返回上一页</a-button></a>
        <a href="index.html"><a-button type="primary" :block="false" style="margin:10px 0 0 0">返回首页</a-button></a>
    </div>
</div>
</template>  

<script>
export default {
    props:['code', 'msg'],
    data() {
        return {
            message: {
                404: '抱歉，您访问的页面不存在',
                403: '抱歉，你无权访问该页面',
                500: '抱歉，服务器出错了',
            }
        }
    }
}
</script>

<style lang="less" scope>
.error_page {
    min-height: 600px;
    display: flex;
    align-items: center;
    justify-content: center;
    .error_img {
        width:500px;
        height:500px;
        background: url('../../assets/img/500.jpg') no-repeat center;
        margin: 0 100px 0 0;
        &.error_403 {
            background: url('../../assets/img/403.jpg') no-repeat center;
        }
        &.error_404 {
            background: url('../../assets/img/404.jpg') no-repeat center;
        }
    }
    .error_info {
        max-width: 500px;
        min-width: 200px;
        display: flex;
        justify-content: center;
        flex-direction: column;
       h1  {
           font-size: 60px;
           color: #545454;
           margin:0;
       } 
       p {
           font-size: 20px;
           color:#797979;
       }
       .ant-btn {
           width:100px;
       }
    }
}
</style>